'use client';

import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { Text } from "../Text/Text.js";
import { classNames } from "../../utils/styles/classNames.js";
import { itemSuffix, labelSuffix, contentGap, content } from "./MenuItem.css.js";
import { getLabelId, getCaptionId } from "./utils/constants.js";
import { variantColor } from "./utils/typed-constants.js";
import { MenuItemStatus } from "./MenuItem.Status.js";
function MenuItemContent(props) {
  const {
    icon: Icon,
    iconStyle,
    iconPosition,
    label,
    status,
    caption,
    disabled,
    variant,
    a11yLabel,
    id
  } = props;
  const hasEndIcon = iconPosition === "end";
  const iconJsx = Icon && /* @__PURE__ */ jsx(
    Icon,
    {
      className: classNames(hasEndIcon && itemSuffix),
      filled: iconStyle === "filled",
      size: "md"
    }
  );
  const hasStatus = !!(status == null ? void 0 : status.label);
  const hasLabelSuffix = hasStatus || hasEndIcon;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !hasEndIcon && iconJsx,
    /* @__PURE__ */ jsxs("span", { className: classNames(content, hasStatus && contentGap), children: [
      a11yLabel && /* @__PURE__ */ jsx(Text, { id: getLabelId(id), visuallyHidden: true, children: a11yLabel }),
      /* @__PURE__ */ jsxs(
        Text,
        {
          "aria-hidden": a11yLabel ? "true" : void 0,
          as: "span",
          color: disabled ? "onLight.disabled.muted" : variantColor[variant || "default"],
          id: a11yLabel ? void 0 : getLabelId(id),
          variant: "body.base",
          children: [
            label,
            hasLabelSuffix && /* @__PURE__ */ jsxs("span", { className: labelSuffix, children: [
              hasEndIcon && iconJsx,
              hasStatus && /* @__PURE__ */ jsx(MenuItemStatus, { ...props })
            ] })
          ]
        }
      ),
      caption && /* @__PURE__ */ jsx(
        Text,
        {
          color: "onLight.text.tertiary",
          id: getCaptionId(id),
          variant: "body.xs",
          children: caption
        }
      )
    ] })
  ] });
}
export {
  MenuItemContent
};
